import { Image as AntImage } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Button as ButtonComponent } from 'components/Button';
import type { TInfoBlockProps } from './index';

const TYPE_STYLES: Record<
  TInfoBlockProps['type'],
  Record<'title' | 'price', FlattenSimpleInterpolation>
> = {
  plain: {
    title: css`
      color: var(--v3-text-color);
    `,
    price: css`
      color: var(--v3-text-color);
    `
  },
  contrast: {
    title: css`
      color: var(--v3-primary-color);
    `,
    price: css`
      color: var(--v3-primary-color);
    `
  }
};

export const Image = styled(AntImage)`
  width: auto;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-top: 16px;
  text-align: center;
  letter-spacing: -0.02em;
`;

export const Description = styled.div`
  font-weight: 450;
  font-size: 18px;
  line-height: 24px;
  margin-top: 4px;
  text-align: center;
`;

export const Price = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
`;

export const Button = styled(ButtonComponent)<{ $wide?: boolean }>`
  &&&& {
    justify-content: center;
    max-width: 100%;
    width: ${({ $wide }) => ($wide ? '100%' : 'fit-content')};
    padding-left: 40px;
    padding-right: 40px;
    margin-top: ${({ $wide }) => ($wide ? '0' : '20px')};
`;

export const HintText = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: var(--v3-text-color-secondary);
  margin-top: 40px;
  text-align: center;
`;

export const InfoBlock = styled.div<{
  type: TInfoBlockProps['type'];
  $alignToTop?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ $alignToTop }) =>
    $alignToTop ? 'flex-start' : 'center'};
  width: 100%;
  height: 100%;
  padding: 30px;

  ${Title} {
    ${({ type }) => TYPE_STYLES[type].title}
  }

  ${Price} {
    ${({ type }) => TYPE_STYLES[type].price}
  }
`;
